import IntegrateSearchFilter from './integrate-search-filter.vue';

export default IntegrateSearchFilter;



// WEBPACK FOOTER //
// ./src/FcComponents/integrate-search-filter/index.js